import React from 'react';
import { KdevIconFont } from '../../../KdevIconFont';
import {
    new_kdev_close,
    new_kdev_document,
    new_kdev_expand,
} from '@kid/enterprise-icon/icon/output/icons';
import { Tooltip } from 'antd';
import { observer } from 'mobx-react';
import classnames from 'classnames';

import { menuCollapsedStore } from '../../../../shared/libs/a-component/route/menus/menuStatusStore';
import PopoverEllipsis from '../../../../shared/common/components/PopoverEllipsis';

import css from './PageLayoutSiderFooter.less';

export interface IKDevSiderFooterProps {
    onToggle?: (() => void) | null;
    footerText?: string;
    onFooterTextClick?: (() => void) | null;
}

const emptyFn =  () => {};

@observer
export class KDevSiderFooter extends React.Component<IKDevSiderFooterProps> {
    renderFooterExtra(expand: boolean) {
        const onFooterTextClick = this.props.onFooterTextClick;
        if (expand) {
            return (
                <div className={css.textBox} onClick={onFooterTextClick || emptyFn}>
                    <KdevIconFont className={css.icon} id={new_kdev_document} />

                    <PopoverEllipsis title={this.props.footerText}>
                        <span className={css.text}>
                            {this.props.footerText}
                        </span>
                    </PopoverEllipsis>
                </div>
            );
        }
        return (
            <Tooltip title={this.props.footerText} placement="right" className={css.iconClick}>
                <span onClick={onFooterTextClick || emptyFn}>
                    <KdevIconFont className={css.icon} id={new_kdev_document} />
                </span>
            </Tooltip>
        );
    }

    renderCollapseIcon(expand: boolean) {
        const icon = expand ? new_kdev_close : new_kdev_expand;
        return (
            <span onClick={this.props.onToggle || emptyFn} className={!expand ? css.iconClick : ''}>
                <KdevIconFont className={css.icon} id={icon} />
            </span>
        );
    }

    render(): React.ReactNode {
        const expand = !menuCollapsedStore.collapsed;

        return (
            <div
                className={classnames(
                    expand ? css.siderFooter : css.siderFooterCollapse
                )}
            >
                {this.props.footerText ? (
                    <div
                        className={classnames(
                            css.footerItem,
                            css.display,
                            css.leftBox
                        )}
                    >
                        {this.renderFooterExtra(expand)}
                    </div>
                ) : null}
                {expand && !this.props.footerText ? (
                    <div
                        className={classnames(css.footerItem, css.leftBox)}
                    ></div>
                ) : null}
                <div
                    className={classnames(
                        css.footerItem,
                        css.display,
                        css.collapseIconBox
                    )}
                >
                    {this.renderCollapseIcon(expand)}
                </div>
            </div>
        );
    }
}
